export default "__VITE_ASSET__Dce1Xc4c__"